import { Dialog } from '../../../components/dialog-portal/dialog.tsx';

interface Props {
    onClose: () => void;
}

// Explains how operators are assigned to daily report categories.
export function OperatorRulesDialog({ onClose }: Props) {
    return (
        <Dialog title='Operator Count Rules' onClose={onClose}>
            <div style={{ maxWidth: 620, lineHeight: 1.5 }}>
                <p>Operator counts are shown only for daily reports. Each operator is counted once per day in one category.</p>
                <p>
                    Operators assigned to day shift D in Resources - Operators are always counted under D, including in past
                    reports.
                </p>
                <p>For other operators, past-day categories are inferred from their recorded actions on the calendar day.</p>
                <p>A single action is classified by its recorded time using the same morning and evening rules.</p>
                <p>
                    Morning shift: the average action time is within the morning shift, and all actions are between 00:00 and
                    14:30. The label is A or B based on that day's shift rotation.
                </p>
                <p>
                    Evening shift: the average action time is within the evening shift, and all actions are between 13:00 and
                    24:00. The label is A or B based on that day's shift rotation.
                </p>
                <p>Actions that do not fit those rules are counted as day shift D.</p>
                <p>For the current day, an operator's Resources - Operators shift assignment is used when one is set.</p>
                <p>Changing an operator's D assignment also changes their category in historical reports when those reports reload.</p>
            </div>
        </Dialog>
    );
}
